import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getStats } from "../../../services/admin.stats.service";

interface StatsSliceState {
  yearlyRevenue: {
    month: string;
    amount: number;
  }[];
  bookings: number;
  orders: number;
  newUsers: number;
  totalAmount: number;
}

const initialState: StatsSliceState = {
  yearlyRevenue: [],
  bookings: 0,
  orders: 0,
  newUsers: 0,
  totalAmount: 0,
};

export const getAdminStats = createAsyncThunk(
  "get/stats",
  async (
    { city, timeRange }: { city: string; timeRange: string },
    { rejectWithValue }
  ) => {
    const { data, error } = (await getStats(timeRange, city)) as {
      data: StatsSliceState;
      error: any;
    };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const slatsSlice = createSlice({
  name: "stats",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getAdminStats.fulfilled, (state, action) => {
      const payload = action.payload;
      state.bookings = payload?.bookings;
      state.orders = payload?.orders;
      state.newUsers = payload?.newUsers;
      state.totalAmount = payload?.totalAmount;
      state.yearlyRevenue = payload?.yearlyRevenue;
    });
  },
});

export default slatsSlice.reducer;
